import React, { useMemo } from "react";
import { Store } from "../../../ui";
import { tx } from "../../ludConnect.constants";
import { merchantAlertInfo } from "../../helpers/ludConnect.helpers";
import "./RestaurantStrip.css";

const RestaurantStrip = ({
  ar,
  restaurants,
  requests,
  selectedId,
  onSelect,
}) => {
  // Group requests by store once, instead of scanning every request for every
  // restaurant on each render.
  const alertsById = useMemo(() => {
    const byStore = new Map();
    requests.forEach((request) => {
      const storeId = request.storeCode ?? request.payload?.restId;
      if (!byStore.has(storeId)) byStore.set(storeId, []);
      byStore.get(storeId).push(request);
    });
    return new Map(
      restaurants.map((restaurant) => [
        restaurant.id,
        merchantAlertInfo(restaurant, byStore.get(restaurant.id) || []),
      ]),
    );
  }, [restaurants, requests]);

  const labels = {
    new: tx(
      "تسجيل/ربط جديد بانتظار الرد",
      "New registration/connection waiting for response",
      ar,
    ),
    edit: tx("تعديل بانتظار الرد", "Edit waiting for response", ar),
    issue: tx("فيه مشكلة", "Has an issue", ar),
  };

  return (
    <>
      <div className="lud-connect__restaurant-strip">
        {restaurants.length === 0 && (
          <span className="lud-connect__muted">
            {tx(
              "لا توجد مطاعم مطابقة للفلاتر",
              "No restaurants match the filters",
              ar,
            )}
          </span>
        )}
        {restaurants.map((restaurant) => {
          const alerts = alertsById.get(restaurant.id);
          return (
            <button
              key={restaurant.id}
              type="button"
              aria-pressed={selectedId === restaurant.id}
              className={`lud-connect__restaurant-pill ${selectedId === restaurant.id ? "active" : ""} ${alerts.hasIssue ? "issue" : alerts.hasNewReg ? "new" : alerts.hasEdit ? "edit" : ""}`}
              onClick={() => onSelect(restaurant.id)}
            >
              <span className="lud-connect__restaurant-logo" aria-hidden="true">
                <Store size={16} />
              </span>
              <span>
                <b>
                  {restaurant.name}
                  {alerts.hasNewReg && (
                    <i className="dot new" role="img" aria-label={labels.new} title={labels.new} />
                  )}
                  {alerts.hasEdit && (
                    <i className="dot edit" role="img" aria-label={labels.edit} title={labels.edit} />
                  )}
                  {alerts.hasIssue && (
                    <i className="dot issue" role="img" aria-label={labels.issue} title={labels.issue} />
                  )}
                </b>
                <small>
                  {alerts.count} {tx("طلب مفتوح", "open requests", ar)}
                </small>
              </span>
            </button>
          );
        })}
      </div>
      <div className="lud-connect__legend">
        <span>
          <i className="dot new" aria-hidden="true" /> {labels.new}
        </span>
        <span>
          <i className="dot edit" aria-hidden="true" /> {labels.edit}
        </span>
        <span>
          <i className="dot issue" aria-hidden="true" /> {labels.issue}
        </span>
      </div>
    </>
  );
};

export default RestaurantStrip;
